<template>
  <div class="nut-banner banner-imunitate">
    <div class="container">
      <div class="row height-400">
        <div class="col-12">
          <h1>DA PENTRU <br> IMUNITATE</h1>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.nut-banner.banner-imunitate {
  position: relative;
  background-image: url("../../assets/images/pentru-imunitate/banner-1366.png");
  height: 400px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  padding: 0;
}

.nut-banner.banner-imunitate .container .row {
  height: inherit;
}

.nut-banner.banner-imunitate:after {
  width: 100%;
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

.nut-banner.banner-imunitate h1 {
  color: white;
  bottom: 40px;
  position: absolute;
  width: 320px;
  font-size: 44px;
  font-weight: 700;
  margin-bottom: 0.5rem;
  line-height: 50px;
  margin-left: 100px;
  z-index: 5;
}

.nut-banner.banner-imunitate h1 span {
  font-size: 40px;
  font-weight: 900;
  line-height: 35px;

}

.nut-banner .arrow-right {
  position: absolute;
  right: 0;
  top: 15px;
  z-index: 15;
}

.nut-banner .arrow-left {
  position: absolute;
  right: 0;
  top: 60px;
  z-index: 15;
}

.nut-banner .doctor {
  position: relative;
  top: 522px;
  z-index: 9;
}

.icon-doctor h2 {
  font-size: 16px;
  font-weight: 600;
  color: #009FE3;
}
.icon-doctor .align-items-center{
  margin: 0;
}
.icon-doctor h2 span {
  font-size: 14px;
  font-weight: 400;
  color: #17479E;
}

.doctor-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 0;
  max-width: 955px;
  margin: auto;
  p{
    color: #029FE3;
    font-weight: 500;
  }
  .doctor-info{
    text-align: center;
    .doctor-img{
      margin-bottom: 20px;
    }
    .name-doctor{
      h2{
        color: #009FE3;
        font-size: 20px;
        span{
          font-size: 16px;
          color: #707070;
        }
      }
    }
  }

}





@media only screen and (max-width: 992px) {
  .nut-banner.banner-imunitate {
    background-size: cover;
  }
  .nut-banner.banner-imunitate h1 {
    padding-left: 30px;

  }

}

@media screen and (max-width: 768px) {
  .nut-banner.banner-imunitate {
    background-image: url("../../assets/images/pentru-imunitate/banner-1366-mobile.png");
    position: relative;
    height: 400px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}

@media only screen and (max-width: 576px) {

  .nut-banner.banner-imunitate h1 {
    margin: auto;
    text-align: center;
    width: 90%;
    padding: 0;
    top: initial;
  }
  .nut-banner.banner-imunitate h1 span {
    font-size: 28px;
    line-height: 30px;
  }
}


@media screen and (max-width: 400px) {
  .nut-banner.banner-imunitate {
    position: relative;
    background-image: url("../../assets/images/pentru-imunitate/copil.png");
    height: 380px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .nut-banner.banner-imunitate h1 {
    font-size: 14px;
  }
  .nut-banner.banner-imunitate h1 {
    font-size: 38px;
    line-height: 44px;
    margin: auto;
    text-align: center;
    width: 85%;
    padding: 0;

  }
  .nut-banner.banner-imunitate h1 {
    padding-left: 15px;

  }
}
</style>
